/**
 * Application Configuration
 * აპლიკაციის კონფიგურაცია
 *
 * Environment URLs are injected at build time via Docker build args.
 * See Dockerfile for VITE_* environment variable configuration.
 */

import type { KeycloakConfig, ApiConfig } from '@aiia/portal-core';

// Environment variables
const ENV = {
  KEYCLOAK_URL: import.meta.env.VITE_KEYCLOAK_URL || 'http://localhost:8180',
  KEYCLOAK_REALM: import.meta.env.VITE_KEYCLOAK_REALM || 'aiia',
  KEYCLOAK_CLIENT_ID: import.meta.env.VITE_KEYCLOAK_CLIENT_ID || 'portal-frontend',
  API_URL: import.meta.env.VITE_API_URL || 'http://localhost:8080',
  AGENT_URL: import.meta.env.VITE_AGENT_URL || 'http://localhost:8081',
  WIDGET_CDN_URL: import.meta.env.VITE_WIDGET_CDN_URL || '',
};

// Keycloak configuration
export const keycloakConfig: KeycloakConfig = {
  url: ENV.KEYCLOAK_URL,
  realm: ENV.KEYCLOAK_REALM,
  clientId: ENV.KEYCLOAK_CLIENT_ID,
};

// API configuration
export const apiConfig: ApiConfig = {
  baseUrl: `${ENV.API_URL}/api/v1`,
  timeout: 30000,
};

// App configuration
export const appConfig = {
  appName: 'AIIA Portal',
  version: '1.0.0',
  supportEmail: 'support@aiia.io',
};
